import React from "react";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import { useState } from "react";
import { Container } from "react-bootstrap";
import { AnimatePresence } from "framer-motion";
import CostMasterCard from "./CostMasterCard";
import CostMasterTable from "./CostMasterTable";
import { useEffect } from "react";
import configServ from "../../services/config";
import { toast } from "react-hot-toast";

const CostMasterPage = () => {
  //#region
  const [isCreate, setIsCreate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [costMasterList, setCostMasterList] = useState([]);
  const [loading, setLoading] = useState(true);

  const handlePopup = () => {
    setIsCreate(!isCreate); // Toggles the visibility of the MenuCard
    setIsEdit(false);
  };

  const handleEditData = (data) => {
    setIsEdit(true);
    setIsCreate(true);
    setEditData(data);
  };

  const fetchCostMaster = async () => {
    setLoading(true);
    try {
      const res = await configServ.getAllCostMasters();
      if (res.status === 200) {
        setCostMasterList(res.data || []);
      } else {
        setCostMasterList([]);
        toast.error("Failed to fetch menu list.");
      }
    } catch (e) {
      toast.error("An error occurred!");
      console.error(e);
      setCostMasterList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCostMaster();
  }, []);

  const onDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this CostMaster?");
    if (!confirmDelete) return;
  
    try {
        const dataToSend = {
            id : id
        }
      setLoading(true);
      const res = await configServ.  deleteCostMaster(dataToSend);
      if (res.status === 200) {
        toast.success("CostMaster deleted successfully!");
        fetchCostMaster(); // Refresh the list after deletion
      } else {
        toast.error("Failed to delete CostMaster.");
      }
    } catch (e) {
      toast.error("An error occurred!");
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  
  //#endregion
  return (
    <Container>
      {/* Header */}
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Cost Master"}
        handlePopup={handlePopup}
        create={isCreate}
        isEdit={isEdit}
        setEditData={setEditData}
      />

      {/* Animated Card */}
      <AnimatePresence>
        {isCreate && (
          <CostMasterCard
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            editData={editData}
            // clear={clear}
            isCreate={isCreate} // State passed as a prop
            setIsCreate={setIsCreate} // Function passed as a prop
            fetchCostMaster={fetchCostMaster} // Pass fetch function
            // permissionsList={permissionsList}
          />
        )}
      </AnimatePresence>
      <CostMasterTable
        onDelete={onDelete}
        loading={loading} // Pass the loading state
        costMasterList={costMasterList}
        handleEditData={handleEditData}
      />
    </Container>
  );
};

export default CostMasterPage;
